import { POST_TYPE } from "../../types"
import ForYouDataSource from "./ForYouSource"
import SubscriptionsDataSource from "./SubscriptionSource"
import TrendingDataSource from "./TrendingDataSource"
import RecentDataSource from "./RecentDataSource"
import TrendingFarcasterDataSource from "./TrendingFarcasterDataSource"
import FarcasterFollowersDataSource from "./FarcasterFollowersDataSource"
import { DataSource } from "./base"

/**
 * Factory method. Given a type and the data source params, create a new data source.
 */
export default function createDataSource({
  type,
  userId,
  walletAddress,
}: {
  type: POST_TYPE
  userId?: string
  walletAddress?: string
}): DataSource {
  switch (type) {
    case "FOR_YOU":
      return new ForYouDataSource(userId, walletAddress)
    case "SUBSCRIPTIONS":
      return new SubscriptionsDataSource(userId)
    case "TRENDING":
      return new TrendingDataSource()
    case "RECENT":
      return new RecentDataSource()
    case "TRENDING_ON_FARCASTER":
      return new TrendingFarcasterDataSource()
    case "FARCASTER_FOLLOWERS":
      return new FarcasterFollowersDataSource(walletAddress)
    default:
      throw new Error("Invalid data source type")
  }
}
